module.exports = __webpack_public_path__ + "assets/img/CustomerCase.2de643ab.png";